import {AuthService} from './auth.service';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {UserBoardService} from '../../_services/user-board.service';
import {AdminService} from '../../_services/admin.service';
import {UserModel} from '../../_models/_firebaseObjects/UserModel';
import {Observable, pipe} from 'rxjs/Rx';
import {map} from 'rxjs/operators';

@Injectable()
export class RoleGuard implements CanActivate {
  isAdmin = false;

  constructor(public auth: AuthService, public router: Router, private userBoardService: UserBoardService, private adminService: AdminService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if(!this.auth.isAuthenticated()) {
      return false;
    }

    // this will be passed from the route config
    // on the data property
    return this.adminService.getUserDetails().map((user: UserModel) => {
      if(!user){
        return false;
      }
      console.log(user);
      if(user['role'] === 'rootAdmin') {
        //console.log('admin');
        return true;
      }
      return false;
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/shared/auth/role-guard.service.ts